'use client'

import { useInView } from 'react-intersection-observer'
import { useEffect, useState } from 'react'
import { useGetCategoriesMutation } from '@/shared/api-rtk/index.js'
import { TOAST_ERROR } from '@/shared/constants/toastTypes.js'
import { usePathname, useRouter } from 'next/navigation'
import Link from 'next/link'
import { FaArrowLeft } from 'react-icons/fa'
import ArrowLeftIcon from '@/shared/components/svgIcons/ArrowLeft'

export const Category = ({ currentConfig, changeConfigRequest }) => {
    const pathname = usePathname()
    const router = useRouter()
    const { ref, inView } = useInView({
        threshold: 0,
        triggerOnce: true,
    })
    const [categories, setCategories] = useState([])
    const [getCategoriesCatalog] = useGetCategoriesMutation()

    useEffect(() => {
        getCategoriesCatalog(currentConfig.category_id)
            .unwrap()
            .then((res) => {
                if (res.result === 'success') {
                    setCategories(Object.values(res.data))
                }
                if (res.error) {
                    setCategories([])
                }
            })
            .catch(() => {
                TOAST_ERROR('Ошибка получения категорий')
            })
    }, [currentConfig.category_id])

    return (
        <div
            ref={ref}
            className={`Category ${inView && 'animate__animated animate__slideInLeft'}`}
        >
            {!!categories.length && <h2>Категории</h2>}
            <div className="categories">
                <button
                    onClick={() => router.back()}
                    className="Category button-back"
                >
                    <ArrowLeftIcon color='black' className={'arrow-left-icon'} width={20} height={20}/>
                    <span>вернуться назад</span>
                </button>

                {categories.map((item) => (
                    <Link
                        key={item.category_id}
                        href={`/${item.catalog_href}`}
                        onClick={() =>
                            changeConfigRequest({
                                ...currentConfig,
                                namePage: item.name,
                                categories: [
                                    ...currentConfig.categories,
                                    pathname,
                                ],
                            })
                        }
                        className="category-catalog"
                    >
                        {item.name}
                    </Link>
                ))}
            </div>
        </div>
    )
}